<template>
  <footer class="fixed-bottom">
    <b-alert v-model="appMessageCountDown"
            dismissible
            :variant="appMessageVariant"
            @closed="dismissCountDown(0)"
            @close-count-down="dismissCountDown">
      {{appMessage}}
    </b-alert>
  </footer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'apperror',
  computed: {
    ...mapGetters(['appMessage', 'appMessageVariant', 'appMessageCountDown'])
  },
  methods: {
    ...mapActions({
      dismissCountDown: 'dismissCountDown'
    })
  }
}
</script>

<style scoped>
footer {
  padding: 0px;
  text-align: center;
  color: #999999;
  z-index: 9999;
}
.alert {
  margin: 5px;
}
</style>
